import { Spine } from "@esotericsoftware/spine-pixi-v8";
// import { sound } from "@pixi/sound";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
// import { SoundConstants } from "../../gameClientEvents/SoundConstants";

export class Transition extends DisplayObject {
    private introTransition: Spine;

    constructor(config: IDisplayObject) {
        super(config);

        this.introTransition = Spine.from({
            skeleton: "introTransitionSkel",
            atlas: "introTransitionAtlas"
        });

        this.introTransition.label = "introTransition";
        this.addChild(this.introTransition);
    }

    public play(): void {
        this.introTransition.state.setAnimation(0, "animation", false);
        // sound.play(SoundConstants.BALLONS_TRANSITION, {
        //     volume: 1,
        // });
    }
}